import React from 'react';
import { Switch } from 'react-router-dom';
import Private from './private/private';
import Auth from './auth';
import { AppStyled } from './index.styled';
import ToastContainerStyled from 'components/ui/toastify/toastify';
import useAuth from 'hooks/use-auth';

function App() {
    const isLoggedIn = useAuth();

    return (
        <div className="App">
            <AppStyled />
            {/* Xendit NEX - Admin Portal */}
            <Switch>{isLoggedIn ? <Private /> : <Auth />}</Switch>
            <ToastContainerStyled />
        </div>
    );
}

export default App;
